<div class="table-container" style="flex: 1; display: flex; flex-direction: column; min-height: 0; overflow-x: hidden;">
  <table class="table-header" sortable-table="sortable-table" (sorted)="onSorted($event)">
    <colgroup>
      <col width="25%"/>
      <col width="15%"/>
      <col width="15%"/>
      <col width="40%"/>
      <col width="5%"/>
    </colgroup>
    <thead>
      <tr>
        <th sortable-column="name">Branch Name</th>
        <th sortable-column="site_count">Sites</th>
        <th sortable-column="user_count">Users</th>
        <th sortable-column="description">Description</th>
        <th></th>
      </tr>
    </thead>
  </table>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="table-body" *ngIf="!isLoading" style="flex: 1; min-height: 0; overflow-x: hidden; overflow-y: auto;">
    <table>
      <colgroup>
        <col width="25%"/>
        <col width="15%"/>
        <col width="15%"/>
        <col width="40%"/>
        <col width="5%"/>
      </colgroup>
      <tbody>
        <ng-container *ngIf="!filteredDivisions.length">
          <tr *ngIf="!hasReadDivisionPermission" style="text-align: center; color: #999;">
            <td colspan="11">No Permission for Branch List</td>
          </tr>
          <tr *ngIf="hasReadDivisionPermission" style="text-align: center; color: #999;">
            <td colspan="11">No branches yet. Create a branch to give an office or install team access to a defined set of your sites.</td>
          </tr>
        </ng-container>
        <tr class="has-child" *ngFor="let division of filteredDivisions" (click)="goToDetail(division.id)">
          <td>{{division.name}}</td>
          <td>{{division.site_count}} sites</td>
          <td>{{division.user_count}} users</td>
          <td>{{division.description}}</td>
          <td>
            <div class="more-content v-center" #actionMenus [id]="'division-'+division?.id" (mouseover)="setDivisionMorePosition(division)">
              <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(division)">
                <i class="material-icons" style="font-size: 20px; color: hsla(0, 0%, 0%, 0.87);">more_horiz</i>
              </div>
              <div class="more" [class.show]="division.isShowMenu" [id]="'division-more-'+division.id">
                <div class="more-item" (click)="$event.stopPropagation(); goToDetail(division.id)">Go to Detail</div>
                <div class="more-item" *ngIf="hasUpdateDivisionPermission" (click)="$event.stopPropagation(); editDivision(division)">Edit Branch</div>
                <div class="more-item danger" *ngIf="hasDeleteDivisionPermission" (click)="$event.stopPropagation(); deleteDivision(division)">Remove Branch</div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>